import KeynoteSpeakers from "./assets/pages/2026/KeynoteSpeakers";
import Home from './assets/pages/2024/Home';
import Layout from './assets/pages/2024/Layout';
import About from './assets/pages/2024/About';
import Registration from './assets/pages/2024/Registration';
import NoPage from './assets/pages/2024/NoPage';
import ComingSoon from './assets/pages/2024/ComingSoon';
import RegistrationForm2026 from './assets/pages/2026/RegistrationForm';

import EventDetails from './assets/pages/2024/EventDetails';


// import speaker from './assets/js/speaker.js';
import { createBrowserRouter, Routes, Route, createRoutesFromElements, RouterProvider, BrowserRouter, Navigate } from "react-router-dom";
import Contact from './assets/pages/2024/Contact';

import Venue from './assets/pages/2024/Venue';
import Supporters from './assets/pages/2024/Supporters';
import Speakers from './assets/pages/2024/Speakers';
import Committee from './assets/pages/2024/Committee';
import LandingPage from './assets/pages/2024/LandingPage';
import { partnerLogos } from './assets/components/PartnerLogos';


import Home2025 from './assets/pages/2025/Home';
import Layout2025 from './assets/pages/2025/Layout';
import About2025 from "./assets/pages/2025/About";
import EventDetails2025 from "./assets/pages/2025/EventDetails";
import { partnerLogos2025 } from './assets/components2025/PartnerLogos';
import Speakers2025 from './assets/pages/2025/Speakers';
import Supporters2025 from './assets/pages/2025/Supporters';
import Venue2025 from './assets/pages/2025/Venue';
import Registration2025 from './assets/pages/2025/Registration';
import Committee2025 from './assets/pages/2025/Committee';
import Awards2025 from './assets/pages/2025/Awards';
import Contact2025 from './assets/pages/2025/Contact';
import Author from "./assets/pages/2025/Author"

import Home2026 from './assets/pages/2026/Home';
import Layout2026 from './assets/pages/2026/Layout';
import About2026 from "./assets/pages/2026/About";
import EventDetails2026 from "./assets/pages/2026/EventDetails";
import Speakers2026 from './assets/pages/2026/Speakers';
import Supporters2026 from './assets/pages/2026/Supporters';
import Venue2026 from './assets/pages/2026/Venue';
import Registration2026 from './assets/pages/2026/Registration';
import Committee2026 from './assets/pages/2026/Committee';
import Awards2026 from './assets/pages/2026/Awards';
import Contact2026 from './assets/pages/2026/Contact';
import Author2026 from "./assets/pages/2026/Author"
import FinalPaperSubmission2026 from './assets/pages/2026/FinalPaperSubmission';
import NoPage2026 from "./assets/pages/2026/NoPage"
import { partnerLogos2026 } from './assets/components2026/PartnerLogos';





// const router = createBrowserRouter(
//   createRoutesFromElements(

//   )
// )

function App() {

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Navigate to="/2026" replace />} />
          <Route path="/2024" element={<Layout logos={partnerLogos} />}>
            <Route path='/2024' element={<Home day={27} month={11} year={2024} startTime="10:00 AM" endTime="2:00 PM" weekDay="WED" venue="NSE Auditorium, Mumbai" />} />
            <Route path="/2024/about" element={<About />} />
            <Route path="/2024/speakers" element={<Speakers />} />
            <Route path="/2024/eventDetails" element={<EventDetails />} />
            <Route path="/2024/committee" element={<Committee />} />
            <Route path='/2024/venue' element={<Venue />} />
            <Route path='/2024/supporters' element={<Supporters />} />

            <Route path="/2024/registration" element={<Registration />} />


            <Route path="/2024/contact" element={<Contact />} />

            <Route path="*" element={<NoPage />} />
          </Route>

          <Route path="/2025" element={<Layout2025 logos={partnerLogos2025} />}>
            <Route path='/2025' element={<Home2025 day={13} month={12} year={2025} startTime="10:00 AM" endTime="6:00 PM" weekDay="SAT" venue="IIT Bombay, Mumbai" />} />
            <Route path="/2025/about" element={<About2025 />} />
            <Route path="/2025/speakers" element={<Speakers2025 />} />
            <Route path="/2025/eventDetails" element={<EventDetails2025 />} />
            <Route path="/2025/committee" element={<Committee2025 />} />
            <Route path="/2025/awards" element={<Awards2025 />} />
            <Route path='/2025/venue' element={<Venue2025 />} />
            <Route path='/2025/supporters' element={<Supporters2025 />} />
            <Route path="/2025/registration" element={<Registration2025 />} />
            <Route path="/2025/contact" element={<Contact2025 />} />
            <Route path='/2025/author' element={<Author />} />

            <Route path="*" element={<NoPage />} />
          </Route>

          <Route path="/2026" element={<Layout2026 logos={partnerLogos2026} />}>
            <Route path='/2026' element={<Home2026 day={4} endDay={5} month={12} year={2026} startTime="10:00 AM" endTime="6:00 PM" weekDay="SAT" venue="IIT Bombay, Mumbai" />} />
            <Route path="/2026/about" element={<About2026 />} />
            <Route path="/2026/speakers" element={<Speakers2026 />} />
            <Route path="/2026/eventDetails" element={<EventDetails2026 />} />
            <Route path="/2026/committee" element={<Committee2026 />} />
            <Route path="/2026/awards" element={<Awards2026 />} />
            <Route path='/2026/venue' element={<Venue2026 />} />
            <Route path='/2026/supporters' element={<Supporters2026 />} />
            <Route path="/2026/registration" element={<Registration2026 />} />
            <Route path="registration/form" element={<RegistrationForm2026 />} />
            <Route path="/2026/contact" element={<Contact2026 />} />
            <Route path='/2026/author' element={<Author2026 />} />
            <Route path="author/final-paper-submission" element={<FinalPaperSubmission2026 />} />
            <Route path="/2026/program/keynote-speakers" element={<KeynoteSpeakers />} />
            <Route path="*" element={<NoPage2026 />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
